import 'navigator.sendbeacon';
var url = "/events/track";
function getPayload(csrfToken, deviceSessionId, props) {
    var _a, _b, _c;
    return {
        event: props.action,
        properties: (_a = props.other) !== null && _a !== void 0 ? _a : null,
        model: (_b = props.model) !== null && _b !== void 0 ? _b : null,
        uid: (_c = props.uid) !== null && _c !== void 0 ? _c : null,
        device_session_id: deviceSessionId,
        YII_CSRF_TOKEN: csrfToken,
    };
}
function trackEventClientside(csrfToken, deviceSessionId, props) {
    if (typeof window === 'undefined') {
        return;
    }
    var data = getPayload(csrfToken, deviceSessionId, props);
    var blob = new Blob([JSON.stringify(data)], { type: 'application/json' });
    window.navigator.sendBeacon(url, blob);
}
export function trackEvent(csrfToken, deviceSessionId, props) {
    trackEventClientside(csrfToken, deviceSessionId, props);
}
//# sourceMappingURL=track-event.js.map